import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="sticky top-0 z-40 bg-background/85 backdrop-blur-md border-b border-border/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center items-center h-20">
          <Link to="/" className="font-serif text-2xl md:text-3xl text-foreground tracking-tight" data-testid="navbar-logo">
            Red Panda <span className="text-primary">Socials</span>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
